import React from 'react';

/**
 * Contact page — provides contact information and branding.
 */
export function ContactPage(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        {/* Prism SVG */}
        <div className="mb-8 flex justify-center">
          <svg
            width="260"
            height="120"
            viewBox="0 0 260 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            className="opacity-90"
          >
            {/* White light beam entering prism */}
            <line x1="0" y1="60" x2="85" y2="60" stroke="#1D1C1D" strokeWidth="3" strokeLinecap="round" />
            {/* Prism (triangle) */}
            <polygon points="90,20 150,20 120,100" fill="none" stroke="#1D1C1D" strokeWidth="2" />
            {/* Seven coloured rays exiting prism */}
            <line x1="160" y1="28" x2="260" y2="8" stroke="#C75B5B" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="161" y1="35" x2="260" y2="25" stroke="#D4874D" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="162" y1="42" x2="260" y2="42" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="162" y1="49" x2="260" y2="58" stroke="#5B9E6F" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="161" y1="56" x2="260" y2="75" stroke="#4D9E9E" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="160" y1="63" x2="260" y2="92" stroke="#4A7FB5" strokeWidth="2.5" strokeLinecap="round" />
            <line x1="158" y1="70" x2="260" y2="108" stroke="#7B5EA7" strokeWidth="2.5" strokeLinecap="round" />
          </svg>
        </div>

        <h1 className="mb-2 text-center text-3xl font-bold text-text-primary">
          Contact Us
        </h1>
        <p className="mb-6 text-center text-sm font-medium text-text-muted italic">
          Reach out about anything shaping your momentum at work.
        </p>

        <p className="text-lg text-text-secondary leading-relaxed">
          Contact us using the Feedback button in the footer to ask questions, share feedback or ideas, or email{' '}
          <a
            href="mailto:appreciativeai@gmail.com"
            className="font-medium text-[#611F69] hover:underline"
          >
            appreciativeai@gmail.com
          </a>{' '}
          directly.
        </p>
      </div>
    </div>
  );
}
